import { useGetErrorBanner } from '@/hooks/useGetErrorBanner';
import { Info, TriangleAlert } from 'lucide-react';
import { useTranslation } from 'react-i18next';

export const ErrorBanner = () => {
  const { data } = useGetErrorBanner();
  const { i18n } = useTranslation();

  if (!data || data.bannerType === 'None') return <></>;

  return (
    <div
      className={`${data.bannerType == 'Error' ? 'bg-red-500' : 'bg-amber-600'} p-4 text-white flex items-start space-x-2`}
    >
      <div className="w-6 h-6 pt-1">
        {data.bannerType == 'Error' ? (
          <TriangleAlert className="w-6 h-6" />
        ) : (
          <Info className="w-6 h-6" />
        )}
      </div>
      <section>
        <h1 className="text-lg font-bold">
          {i18n.language === 'en' ? data.titleEn : data.titleNl}
        </h1>
        <p className="pt-1 text-sm">
          {i18n.language === 'en' ? data.descriptionEn : data.descriptionNl}
        </p>
      </section>
    </div>
  );
};
